import {
  currentUser,
  currentUserVerified,
} from 'Webapp/shared/app/redux/selectors/profile';

export const showAccountVerificationStatus = (state) =>
  !!(currentUser(state) && !currentUserVerified(state));
